(function () {
    'use strict';

    angular.module('app')
        .factory('Idioma', Idioma);

    /* @ngInject */
    function Idioma($resource) {
        return $resource('api/admin/idioma/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/idioma/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/idioma/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/idioma/findAll'
            }
        });
    }
})();
